<template>
  <div class="layout-container">
    <el-container class="main-container" :class="isDomestic ? 'domestic-layout' : ''">
      <el-aside
        class="layout-container-aside "
        :class="menuCollapse?'collapse-aside':''"
      >
        <div class="sidebar-layout">
          <div class="main-left-sidebar">
            <el-header
              class="header-bar"
              @click="goToDashboard"
            >
              <div class="header-bar-box">
                <div
                  v-show="!menuCollapse"
                  class="logo"
                >
                  <el-image
                    class="logo-not-collapse"
                    fit="contain"
                    :src="require('@/assets/img/logo-letter.png')"
                  />
                </div>
                <a
                  v-show="menuCollapse"
                  href="#"
                  class="logo"
                >
                  <div
                    class="logo-collapse"
                  />
                </a>
              </div>
            </el-header>

            <el-menu
              :default-active="menuActiveIndex"
              class="menu-box"
              background-color="none"
              :collapse="menuCollapse"
              @open="openMenu"
              @close="closeMenu"
            >
              <div
                v-for="(menuItem,menuItemIndex) in menus"
                :key="menuItemIndex"
                class="menu-items-box"
              >
                <div
                  v-if="(!menuItem.children || menuItem.children.length === 0) && menuItem.show"
                  class="menu-item-wrapper"
                  @click="changeNav(menuItem)"
                >
                  <div 
                    class="menu-item-box"
                    :class="{'is-active': menuActiveIndex === menuItem.code}"
                  >
                    <span
                      v-if="menuItem.icon"
                      class="menu-icon"
                    >
                      <i
                        v-if="menuItem.iconType === 'iconfont'"
                        class="menu-item-icon icon ag-iconfont"
                        :class="'icon-' + menuItem.icon"
                        aria-hidden="true"
                      />
                      <svg-icon
                        v-else
                        :icon-class="menuActiveIndex === menuItem.code ? menuItem.activeIcon || menuItem.icon : menuItem.icon"
                        class-name="menu-item-icon"
                      />
                    </span>
                  </div>
                  <div 
                  :class="{'is-textactive': menuActiveIndex === menuItem.code}"
                  class="menu-item-label">
                  {{ menuItem.title }}
                </div>
                </div>
                <!-- 隐藏原el-menu-item功能 -->
                <el-menu-item
                  v-if="false && (!menuItem.children || menuItem.children.length === 0) && menuItem.show"
                  :index="menuItem.code"
                  style="display: none;"
                  @click="changeNav(menuItem)"
                >
                  <div class="menu-item-box">
                    <span
                      v-if="menuItem.icon"
                      class="menu-icon"
                    >
                      <svg-icon
                        :icon-class="menuActiveIndex === menuItem.code ? menuItem.activeIcon || menuItem.icon : menuItem.icon"
                        class-name="menu-item-icon"
                      />
                    </span>
                  </div>
                  <template #title>
                    <div class="menu-title">{{ menuItem.title }}</div>
                  </template>
                </el-menu-item>
                <!-- 隐藏原el-sub-menu功能 -->
                <el-sub-menu
                  v-if="false && menuItem.children && menuItem.children.length > 0 && menuItem.show"
                  :index="menuItem.code"
                  style="display: none;"
                >
                  <template #title>
                    <span
                      v-if="menuItem.icon"
                      class="menu-icon"
                    >
                      <i
                        class="menu-item-icon icon ag-iconfont"
                        :class="'icon-'+menuItem.icon"
                      />
                    </span>
                    <div
                      class="menu-title"
                      :class="menuCollapse?'hide-sub-title':''"
                    >{{ menuItem.title }}
                    </div>
                  </template>
                  <div
                    v-for="(subMenuItem,subMenuItemIndex) in menuItem.children"
                    :key="subMenuItemIndex"
                    class="sub-menu-box"
                  >
                    <el-menu-item
                      v-if="(!subMenuItem.children || subMenuItem.children.length === 0) && subMenuItem.show"
                      :index="subMenuItem.code"
                      @click="changeNav(subMenuItem)"
                    >
                      <span
                        v-if="subMenuItem.icon"
                        class="menu-icon"
                      >
                        <i
                          class="menu-item-icon icon ag-iconfont"
                          :class="'icon-'+subMenuItem.icon"
                        />
                      </span>
                      <!--                      <template #title>-->
                      <!--                        <div class="menu-title">{{ subMenuItem.title }}</div>-->
                      <!--                      </template>-->
                    </el-menu-item>
                    <el-sub-menu
                      v-if="subMenuItem.children && subMenuItem.children.length > 0 && subMenuItem.show"
                      :index="subMenuItem.code"
                    >
                      <template #title>
                        <span
                          v-if="subMenuItem.icon"
                          class="menu-icon"
                        >
                          <i
                            class="menu-item-icon icon ag-iconfont"
                            :class="'icon-'+subMenuItem.icon"
                          />
                        </span>
                        <div class="menu-title">{{ subMenuItem.title }}</div>
                      </template>
                      <el-menu-item
                        v-for="(sSubMenuItem,sSubMenuItemIndex) in subMenuItem.children"
                        :key="sSubMenuItemIndex"
                        :index="sSubMenuItem.code"
                        @click="changeNav(sSubMenuItem)"
                      >
                        <span
                          v-if="sSubMenuItem.icon"
                          class="menu-icon"
                        >
                          <i
                            class="menu-item-icon icon ag-iconfont"
                            :class="'icon-'+sSubMenuItem.icon"
                          />
                        </span>
                        <template #title>
                          <div class="menu-title">{{ sSubMenuItem.title }}</div>
                        </template>
                      </el-menu-item>
                    </el-sub-menu>
                  </div>
                </el-sub-menu>
              </div>
            </el-menu>
          </div>
          <div class="bottom-menu-bar">
            <div class="enterprise-contact-wrapper">
              <el-tooltip
                :content="$t('layout.layout.enterprise_contact')"
                effect="dark"
                placement="right"
              >
                <button
                  type="button"
                  class="enterprise-contact-entry"
                  :aria-label="$t('layout.layout.enterprise_contact')"
                  @click="enterpriseContactDialogVisible = true"
                >
                  <span
                    class="enterprise-contact-icon icon ag-iconfont"
                    aria-hidden="true"
                  >&#xe674;</span>
                  <span
                    v-if="!menuCollapse"
                    class="enterprise-contact-label"
                  >{{ $t('layout.layout.enterprise_contact') }}</span>
                </button>
              </el-tooltip>
            </div>

            <!-- 隐藏升级按钮，保留功能 -->
            <div
              v-if="false && !menuCollapse && $store.getters['user/user_sub'] === 'VER_PERSON_FREE_BASICS'"
              class="upgrade-button-wrapper"
              @click="openSubPage"
            >
              <el-button
                type="primary"
                class="upgrade-text-btn"
              >
                {{ $t('layout.layout.upgrade_to_pro') }}
              </el-button>
            </div>
            <!-- 隐藏升级按钮折叠状态，保留功能 -->
            <div
              v-else-if="$store.getters['user/user_sub'] === 'VER_PERSON_FREE_BASICS'"
              class="upgrade-button-wrapper collapsed"
              @click="openSubPage"
            >
              <el-button
                type="primary"
                circle
                class="upgrade-icon-btn"
              ><svg-icon
                class-name="menu-icon"
                icon-class="crown"
              /></el-button>
            </div>

            <!-- 邀请奖励入口 - 侧边栏外侧 -->
            <el-tooltip
              :content="$t('layout.layout.free_credits')"
              :disabled="inviteMenuVisible"
              effect="dark"
              placement="right"
            >
              <div
                class="invite-reward-entry"
                @click.stop="toggleInviteMenu"
              >
                <div class="invite-reward-box">
                  <i
                    class="invite-reward-icon icon ag-iconfont icon-gift-box"
                    aria-hidden="true"
                  />
                </div>
              </div>
            </el-tooltip>

            <div
              v-if="isLoggedIn"
              ref="userMenuTrigger"
              class="bottom-menu-bar-user"
              @click.stop="toggleUserMenu"
            >
              <div class="user-content-box">
                <UserAvatarBadge
                  :size="25"
                  :src="$store.getters['user/avatar'] || require('@/assets/img/def_user.png')"
                  :subscription-key="$store.getters['user/user_sub']"
                />
                <span
                  v-if="!menuCollapse"
                  class="user-info-nick_nam"
                >{{ $store.getters['user/nick_name'] }}</span>
              </div>
            </div>
            <el-button
              v-else
              class="guest-login-button"
              @click.stop="openLogin"
            >
              {{ $t('views.login.login_button') }}
            </el-button>

            <teleport to="body">
              <div
                v-show="isLoggedIn && userMenuVisible"
                class="custom-user-menu-container"
                :style="userMenuPosition"
                @click.stop
              >
                <div class="user-opt-box">
                  <!-- 用户信息头部 -->
                  <div class="user-info-header">
                    <UserAvatarBadge
                      :size="36"
                      :src="$store.getters['user/avatar'] || require('@/assets/img/def_user.png')"
                      :subscription-key="$store.getters['user/user_sub']"
                    />
                    <div class="user-info-details">
                      <div class="username">{{ $store.getters['user/nick_name'] }}</div>
                      <el-tooltip
                        v-if="isEmailOverflow"
                        :content="$store.getters['email']"
                        effect="dark"
                        placement="bottom-end"
                      >
                        <div class="email">{{ truncatedEmail }}</div>
                      </el-tooltip>
                      <div v-else class="email">{{ truncatedEmail }}</div>
                    </div>
                    <el-button
                      v-if="canManageSubscription"
                      class="subscription-btn"
                      type="primary"
                      size="small"
                      @click="openSubPage"
                    >
                      {{ $t('layout.layout.upgrade') }}
                    </el-button>
                  </div>

                  <div class="current-plan-card">
                    <div class="current-plan-points">
                      <div>
                        <div
                            v-if="currentTeamVersionName"
                            class="current-plan-version"
                            :title="currentTeamVersionName"
                        >
                          {{ currentTeamVersionName }}
                        </div>
                      </div>
                      <div>
                        <i class="icon ag-iconfont icon-integral-diamond "/> <strong>{{ displayPoints }}</strong>
                      </div>
                    </div>
                  </div>

                  <button
                    ref="teamMenuTrigger"
                    class="current-team-trigger"
                    type="button"
                    aria-haspopup="menu"
                    :aria-expanded="teamMenuVisible"
                    :title="currentTeamDisplayName"
                    @click.stop="toggleTeamMenu"
                  >
                    <span class="current-team-trigger-icon" aria-hidden="true">
                       <img
                           v-if="currTeam&&currTeam.avatar&&Number(currTeam.team_type)<1"
                           class="current-team-trigger-avatar"
                           :src="currTeam.avatar"
                           alt=""
                       >
                      <i v-else  class="icon ag-iconfont" :class="currentTeamIconClass" />
                    </span>
                    <span class="current-team-trigger-name">{{ currentTeamDisplayName }}</span>
                    <el-icon class="current-team-trigger-arrow"><ArrowRight /></el-icon>
                  </button>

                  <div class="custom-menu" @click="teamMenuVisible = false">
                    <div
                      v-if="canManageCurrentTeam"
                      class="menu-item"
                      @click="openTeamManagement"
                    >
                      <i class="menu-icon icon ag-iconfont icon-company" aria-hidden="true" />
                      <span>{{ $t('layout.layout.team_management') }}</span>
                    </div>
                    <div
                        v-if="currTeam&&currTeam.team_type>0"
                        class="menu-item"
                        @click="showDialogJoinTeam"
                    >
                      <i class="menu-icon icon ag-iconfont icon-user-add" aria-hidden="true" />
                      <span>{{ $t('layout.layout.join_team') }}</span>
                    </div>
                    <!-- 离开团队暂时不开发此功能，只有管理可以移除团队成员-->
<!--                    <div
                      v-if="canLeaveCurrentTeam"
                      class="menu-item danger-menu-item"
                      @click="confirmLeaveCurrentTeam"
                    >
                      <i class="menu-icon icon ag-iconfont icon-back" aria-hidden="true" />
                      <span>{{ $t('layout.layout.leave_team') }}</span>
                    </div>-->

                    <!-- 账号设置 -->
                    <div
                      class="menu-item"
                      @click="openAccountCenter"
                    >
                      <svg-icon
                        class-name="menu-icon"
                        icon-class="account"
                      />
                      <span>{{ $t("layout.layout.account_settings") }}</span>
                    </div>

                    <div
                      class="menu-item"
                      @click="openSubscriptionCenter"
                    >
                      <svg-icon
                        class-name="menu-icon"
                        icon-class="crown"
                      />
                      <span>{{ $t("layout.layout.my_sub") }}</span>
                    </div>



                    <!-- 语言设置 -->
                    <div
                      ref="languageMenuRef"
                      class="menu-item"
                      @click.stop="toggleLanguagePopover($event)"
                    >
                      <svg-icon
                        class-name="menu-icon"
                        icon-class="language"
                      />
                      <span>{{ $t("layout.layout.language") }}</span>
                      <span class="current-lang">{{ currentLanguage.name }}</span>
                      <el-icon><ArrowRight /></el-icon>
                    </div>

                    <!-- 主题设置 -->
                    <div class="menu-item">
                      <svg-icon
                        class-name="menu-icon"
                        icon-class="theme"
                      />
                      <span>{{ $t("layout.layout.theme") }}</span>
                    </div>
                    <div class="theme-options-wrapper">
                      <el-radio-group
                        v-model="themeValue"
                        size="small"
                        @change="themeValueChange"
                      >
                        <el-radio
                          v-for="item in themeOptions"
                          :key="item.id"
                          :value="item.key"
                        >
                          {{ item.name }}
                        </el-radio>
                      </el-radio-group>
                    </div>

                    <!-- 退出登录 -->
                    <div
                      class="menu-item"
                      @click="userLogout"
                    >
                      <svg-icon
                        class-name="menu-icon"
                        icon-class="logout"
                      />
                      <span>{{ $t("layout.layout.logout") }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </teleport>

            <teleport to="body">
              <div
                v-show="isLoggedIn && userMenuVisible && teamMenuVisible"
                class="team-switch-popover"
                :style="teamMenuPosition"
                role="menu"
                :aria-label="$t('layout.layout.current_team')"
                @click.stop
                @keydown.esc.stop="closeTeamMenu"
              >
                <div v-if="orderedTeamSwitchItems.length" class="team-switch-popover-list">
                  <button
                    v-for="teamItem in orderedTeamSwitchItems"
                    :key="teamItem.team_id"
                    class="team-switch-popover-item"
                    :class="{
                      'is-current': isCurrentTeam(teamItem),
                      'is-switching': teamSwitchingId !== null && Number(teamSwitchingId) === Number(teamItem.team_id)
                    }"
                    type="button"
                    role="menuitemradio"
                    :aria-checked="isCurrentTeam(teamItem)"
                    :disabled="teamSwitchingId !== null"
                    :title="getTeamDisplayName(teamItem)"
                    @click="switchUserCurrIdentity(teamItem.team_id)"
                  >
                    <span class="team-switch-popover-icon" aria-hidden="true">
                      <img
                        v-if="teamItem.avatar"
                        class="team-switch-popover-avatar"
                        :src="teamItem.avatar"
                        alt=""
                      >
                      <i v-else class="icon ag-iconfont" :class="getTeamIconClass(teamItem)" />
                    </span>
                    <span class="team-switch-popover-name">{{ getTeamDisplayName(teamItem) }}</span>
                    <i
                      v-if="isCurrentTeam(teamItem)"
                      class="team-switch-popover-check icon ag-iconfont icon-true"
                      aria-hidden="true"
                    />
                  </button>
                </div>
                <div class="team-switch-popover-footer">
                  <button
                    class="team-switch-popover-create"
                    type="button"
                    role="menuitem"
                    :disabled="teamSwitchingId !== null"
                    @click="showDialogCreateTeam"
                  >
                    <span class="team-switch-popover-icon" aria-hidden="true">
                      <i class="icon ag-iconfont icon-add_plus" />
                    </span>
                    <span>{{ $t('layout.layout.create_team') }}</span>
                  </button>
                </div>
              </div>
            </teleport>

            <!-- 语言弹窗 -->
            <teleport to="body">
              <div
                v-show="languagePopoverVisible"
                class="language-popover-container"
                :style="languageMenuPosition"
                @click.stop
              >
                <div class="language-options">
                  <div class="language-options-wrapper">
                    <el-radio-group
                      v-model="languageValue"
                      size="default"
                      @change="languageValueChange"
                    >
                      <el-radio
                        v-for="item in languageOptions"
                        :key="item.id"
                        :value="item.key"
                      >
                        {{ item.name }}
                      </el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
            </teleport>
            <div
                ref="contactInfoTrigger"
                class="contact-info-entry"
                tabindex="0"
                role="button"
                aria-label="更多信息"
                @mouseenter="showContactMenu"
                @mouseleave="scheduleHideContactMenu"
                @focus="showContactMenu"
                @blur="scheduleHideContactMenu"
                @keydown.enter.prevent.stop="showContactMenu"
                @keydown.space.prevent.stop="showContactMenu"
            >
              <div class="contact-info-box">
                <i
                    class="icon ag-iconfont icon-more-horizontal contact-info-icon"
                    aria-hidden="true"
                />
                <span
                    v-if="!menuCollapse"
                    class="contact-info-label"
                >更多</span>
              </div>
            </div>
            <teleport to="body">
              <div
                  v-show="contactInfoVisible"
                  class="contact-menu-popover"
                  :style="contactInfoPosition"
                  @mouseenter="cancelHideContactMenu"
                  @mouseleave="scheduleHideContactMenu"
                  @click.stop
              >
                <div class="contact-menu-list">
                  <div
                      v-for="item in contactMenuItems"
                      :key="item.key"
                      class="contact-menu-item"
                      :class="{ 'is-contact-item': item.key === 'contact', 'is-external-item': !!item.url }"
                      :tabindex="item.key === 'contact' || item.url ? 0 : -1"
                      :role="item.key === 'contact' || item.url ? 'button' : undefined"
                      @keydown.enter.prevent="openContactMenuItem(item)"
                      @keydown.space.prevent="openContactMenuItem(item)"
                      @click="openContactMenuItem(item)"
                  >
                    <span>{{ item.label }}</span>
                  </div>
                </div>
                <div class="contact-menu-divider" />
                <div class="contact-menu-records">
                  <div class="contact-menu-caption">备案信息</div>
                  <a
                      href="https://beian.miit.gov.cn/"
                      target="_blank"
                      rel="noopener noreferrer"

                  >闽ICP备2026022474号-2</a>
                  <a
                      href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020302037392"
                      target="_blank"
                      style="display: flex;gap: 4px;"
                      rel="noopener noreferrer"
                  ><img src="https://beian.mps.gov.cn/web/assets/logo01.6189a29f.png" class="w-full" style="width: 14px; height: 14px;">闽公网安备35020302037392号</a>
                  <div class="contact-menu-caption">
                    厦门智道开物科技有限公司
                  </div>
                </div>
              </div>
            </teleport>
            <hr class="divider">
            <!-- 隐藏菜单折叠按钮，保留功能 -->
            <div
              v-if="false"
              class="menu-collapse-opt"
              :class="menuCollapse ? 'is-collapse-opt' : ''"
              style="display: none;"
              @click="menuCollapse = !menuCollapse"
            >
              <div class="menu-collapse-btn-box">
                <div class="menu-collapse-btn">
                  <i
                    v-if="menuCollapse === false"
                    class="icon ag-iconfont icon-shrink_left"
                  />
                  <i
                    v-else
                    class="icon ag-iconfont icon-shrink_right"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-aside>
      <el-main class="layout-container-main">
        <router-view v-slot="{ Component }">
          <transition
            mode="out-in"
            name="move"
          >
            <component
              :is="Component"
              @changeNav="changeNav"
            />
          </transition>
        </router-view>
      </el-main>
    </el-container>

    <el-dialog
      v-model="contactDialogVisible"
      class="contact-dialog"
      width="400px"
      append-to-body
      :show-close="true"
      :close-on-click-modal="true"
      title="联系我们"
    >
      <div class="contact-dialog-content">
        <div class="contact-dialog-section">
          <div class="contact-dialog-caption">版权所有</div>
          <div class="contact-dialog-value">厦门智道开物科技有限公司</div>
        </div>

        <div class="contact-dialog-section contact-dialog-wechat">
          <div class="contact-dialog-caption">客服微信</div>
          <el-image
            class="contact-dialog-qrcode"
            fit="contain"
            :src="require('@/assets/img/contact_qrcode.jpg')"
            :preview-src-list="[require('@/assets/img/contact_qrcode.jpg')]"
          />
        </div>

        <div class="contact-dialog-section">
          <div class="contact-dialog-caption">电子邮箱</div>
          <a
            class="contact-dialog-link"
            href="mailto:marketing@paiteams.com"
          >marketing@paiteams.com</a>
        </div>

      </div>
    </el-dialog>

    <EnterpriseContactDialog v-model="enterpriseContactDialogVisible" />

    <el-dialog
      v-model="dialogTeamInvitation"
      :close-on-click-modal="false"
      width="800px"
      :title="$t('layout.layout.team_invitation')"
      append-to-body
    >
      <div class="team-invitation-box">
        <TeamInvitation
          v-if="dialogTeamInvitation"
          ref="teamInvitationDlg"
          :is-dialog="true"
          @confirm-end="confirmTeamInvitation"
        />
      </div>
      <template #footer>
        <span
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="submitTeamInvitation()"
          >{{ $t("common.confirm") }}</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="dialogCreateTeam"
      :close-on-click-modal="false"
      width="500px"
      :title="$t('layout.layout.create_team')"
      append-to-body
    >
      <div class="createTeamBox">
        <CreateTeam
          v-if="dialogCreateTeam"
          ref="createTeamDlg"
          :is-dialog="true"
          @update-team="updateTeam"
        />
      </div>
      <template #footer>
        <span
          class="dialog-footer"
        >
          <el-button @click="closeDialogCreateTeam()">{{ $t("common.cancel") }}</el-button>
          <el-button
            type="primary"
            @click="submitCreateTeam()"
          >{{ $t("common.confirm") }}</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="dialogJoinTeam"
      :close-on-click-modal="false"
      width="500px"
      :title="$t('layout.layout.join_team')"
      append-to-body
    >
      <div class="joinTeamBox">
        <CodeJoinTeam
          v-if="dialogJoinTeam"
          ref="joinTeamDlg"
          :is-dialog="true"
          @update-team="updateTeam"
          @close-dlg="closeDialogJoinTeam"
        />
      </div>
      <template #footer>
        <span
          class="dialog-footer"
        >
          <el-button @click="closeDialogJoinTeam()">{{ $t("common.cancel") }}</el-button>
          <el-button
            type="primary"
            @click="submitJoinTeam()"
          >{{ $t("common.confirm") }}</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 账号中心弹窗 -->
    <el-dialog
      v-model="dialogAccountCenter"
      :show-close="false"
      width="1200px"
      class="accountCenterBox"
      destroy-on-close
    >
      <div class="account-center-container">
        <AccountCenter v-if="dialogAccountCenter" @payment-success="accountCenterPaymentSuccess"  />
      </div>
    </el-dialog>

    <!-- 轻量订阅购买弹窗；完整账号中心仍由上面的弹窗承载 -->
    <el-dialog
      v-model="dialogSubscriptionPurchase"
      :show-close="false"
      width="1120px"
      class="subscriptionPurchaseBox"
      append-to-body
      destroy-on-close
      @closed="handleSubscriptionDialogClosed"
    >
      <SubscriptionPurchase
        v-if="dialogSubscriptionPurchase"
        @close="dialogSubscriptionPurchase = false"
        @payment-success="handleSubscriptionPaymentSuccess"
      />
    </el-dialog>

    <PaymentSuccessDialog
      v-if="subscriptionPaymentSuccessVisible"
      :need-reload="true"
      :ver-name="subscriptionPaymentSuccessData.ver_name"
      :benefits-list="subscriptionPaymentSuccessData.present_benefits"
      :order-type="subscriptionPaymentSuccessData.order_type"
      :expand-data="subscriptionPaymentSuccessData.expand_data"
      @closePaymentSuccessDlg="closeSubscriptionPaymentSuccess"
    />

    <!-- 邀请奖励弹窗 -->
    <el-dialog
      v-model="dialogInviteReward"
      width="420px"
      :show-close="false"
      class="invite-reward-dialog"
      append-to-body
      destroy-on-close
    >
      <InviteDialog v-if="dialogInviteReward" @close="dialogInviteReward = false" />
    </el-dialog>

    <!-- 填写邀请码弹窗 -->
    <el-dialog
      v-model="dialogBindInviteCode"
      width="420px"
      :show-close="false"
      class="invite-reward-dialog"
      append-to-body
      destroy-on-close
    >
      <BindInviteCodeDialog v-if="dialogBindInviteCode" @close="dialogBindInviteCode = false" />
    </el-dialog>

    <!-- 邀请菜单（推荐朋友 / 填写邀请码） -->
    <teleport to="body">
      <div
        v-show="inviteMenuVisible"
        class="invite-menu-popover"
        :style="inviteMenuPosition"
        @click.stop
      >
        <div class="invite-menu-item" @click="openInviteReward">
          <svg class="invite-menu-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 21a8 8 0 0 0-16 0"></path><circle cx="10" cy="8" r="5"></circle><path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"></path></svg>
          <span>{{ $t('layout.layout.refer_friend') }}</span>
        </div>
        <div class="invite-menu-item" @click="openBindInviteCode">
          <svg-icon class-name="invite-menu-icon" icon-class="invite-code" />
          <span>{{ $t('layout.layout.bind_invite_code') }}</span>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import CreateTeam from '@/views/user_center/components/create_team'
import CodeJoinTeam from '@/views/user_center/components/code_join_team'
import TeamInvitation from '@/views/user_center/components/invitation'
import SubscriptionPurchase from '@/views/account_center/components/subscription_purchase.vue'
import PaymentSuccessDialog from '@/views/account_center/components/payment_success.vue'
import {getPreferenceConfigs, getUserPreference, switchCurrIdentity, updateUserPreference} from '@/api/user'
import { leaveTeam } from '@/api/team'
import {getContactMenuList} from '@/api/contactMenu'
import {computed, ref} from 'vue'
import SvgIcon from '@/components/SvgIcon/index.vue'
import EventBus from '@/utils/eventBus'
import AccountCenter from '@/views/account_center/index.vue'
import InviteDialog from '@/components/invite/InviteDialog.vue'
import BindInviteCodeDialog from '@/components/invite/BindInviteCodeDialog.vue'
import EnterpriseContactDialog from '@/components/enterprise/EnterpriseContactDialog.vue'
import i18n, { setLocale, setI18nLanguage, getLocale} from '@/locales/i18n'
import getPageTitle from '@/utils/pageTitle'
import { switchTheme, getTheme, getThemeKeyById } from '@/utils/theme'
import { ArrowRight, Bell } from '@element-plus/icons-vue'
import { isAuthenticated, requireAuth } from '@/utils/authGate'
import UserAvatarBadge from '@/components/UserAvatarBadge/index.vue'
export default {
  name: 'PcLayout',
  components: {
    ArrowRight,
    Bell,
    SvgIcon,
    CreateTeam,
    CodeJoinTeam,
    TeamInvitation,
    SubscriptionPurchase,
    PaymentSuccessDialog,
    AccountCenter,
    InviteDialog,
    BindInviteCodeDialog,
    EnterpriseContactDialog,
    UserAvatarBadge
  },
  provide() {
    return {
      menuCollapse: computed(() => this.menuCollapse),
      toggleMenuCollapse: this.toggleMenuCollapse,
      globalEventBus: this.globalEventBus
    }
  },
  setup() {
    const languageMenuRef = ref(null)
    const userMenuTrigger = ref(null)
    const teamMenuTrigger = ref(null)
    const contactInfoTrigger = ref(null)
    return {
      languageMenuRef,
      userMenuTrigger,
      teamMenuTrigger,
      contactInfoTrigger
    }
  },
  data() {
    return {
      menuActiveIndex: '1',
      menuCollapse: true, // 默认折叠状态
      curPath: '/home',
      hidePopover: false,
      dialogCreateTeam: false,
      globalEventBus: EventBus,
      dialogTeamInvitation: false,
      dialogJoinTeam: false,
      userMenuPosition: {
        top: 'auto',
        left: '0px',
        bottom: '50px',
        right: 'auto'
      },
      teamMenuVisible: false,
      teamMenuPosition: {
        top: '0px',
        left: '0px',
        bottom: 'auto',
        right: 'auto'
      },
      teamSwitchingId: null,
      languageMenuPosition: {
        top: 'auto',
        left: '0px',
        bottom: '50px',
        right: 'auto'
      },
      userMenuVisible: false,
      contactInfoVisible: false,
      contactMenuHideTimer: null,
      contactDialogVisible: false,
      enterpriseContactDialogVisible: false,
      contactMenuRecords: [],
      contactInfoPosition: {
        top: '12px',
        left: '0px',
        right: 'auto',
        bottom: 'auto'
      },
      dialogAccountCenter: false,
      dialogSubscriptionPurchase: false,
      subscriptionPaymentSuccessVisible: false,
      pendingSubscriptionPaymentSuccess: null,
      subscriptionPaymentSuccessData: {
        ver_name: '',
        present_benefits: [],
        order_type: 1,
        expand_data: {
          package_name: '',
          description: ''
        }
      },
      dialogInviteReward: false,
      dialogBindInviteCode: false,
      inviteMenuVisible: false,
      inviteMenuPosition: {
        top: 'auto',
        left: '0px',
        bottom: 'auto',
        right: 'auto'
      },
      languagePopoverVisible: false,
      languageValue: 'zh-cn',
      themeValue: 'system',
      themeOptions: [
      ],
      languageOptions: [],
      currentLanguage: {'key': '', name: ''},
      isDomestic: process.env.VUE_APP_LEGAL_REGION === 'domestic'
    }
  },
  computed: {
    isLoggedIn() {
      return Boolean(this.$store.getters['user/accessToken']) && isAuthenticated()
    },
    currTeam() {
      const loadedTeam = this.$store.getters['team/currentTeam'] || {}
      if (loadedTeam.team_id) return loadedTeam
      const userTeam = this.$store.getters['user/current_team'] || {}
      return {
        ...userTeam,
        team_id: userTeam.team_id || userTeam.id,
        team_roles: userTeam.team_roles || []
      }
    },
    currentTeamDetail() {
      return this.$store.getters['team/currentTeamInfo'] || {}
    },
    memberPointsLimit() {
      return this.$store.getters['team/memberPointsLimit'] || {}
    },
    personTeam() {
      return this.$store.getters['team/personalTeam'] || {}
    },
    userTeamList() {
      return this.$store.getters['team/enterpriseTeams'] || []
    },
    teamSwitchItems() {
      return this.$store.getters['team/teams'] || []
    },
    orderedTeamSwitchItems() {
      return this.teamSwitchItems
        .map((team, index) => ({ team, index }))
        .sort((left, right) => {
          const leftPersonal = Number(left.team.team_type) > 0 ? 0 : 1
          const rightPersonal = Number(right.team.team_type) > 0 ? 0 : 1
          return leftPersonal - rightPersonal || left.index - right.index
        })
        .map(item => item.team)
    },
    currentTeamDisplayName() {
      if (Number(this.currTeam.team_type) > 0) {
        return this.$store.getters['user/nick_name'] ||
          this.currTeam.name ||
          this.$t('layout.layout.personal_team')
      }
      return this.currTeam.name || this.$t('layout.layout.current_team')
    },
    currentTeamIconClass() {
      return Number(this.currTeam.team_type) > 0 ? 'icon-user' : 'icon-company'
    },
    teamPointsSurplus() {
      const numericalAuth = this.currentTeamDetail.numerical_auth || {}
      const pointsQuota = numericalAuth.points_quota || numericalAuth
      return Number(pointsQuota.points_quota_surplus_numerical) || 0
    },
    displayPoints() {
      return this.$store.getters['team/displayPoints'] || 0
    },
    currentTeamVersionName() {
      return this.currentTeamDetail.ver_name ||
        (this.$store.getters['user/current_team_ver'] || {}).ver_name || ''
    },
    canManageCurrentTeam() {
      return this.$store.getters['team/canManage']
    },
    canManageSubscription() {
      return this.$store.getters['team/canManageSubscription'] === true
    },
    isCurrentTeamOwner() {
      if (Object.prototype.hasOwnProperty.call(this.currTeam, 'is_owner')) {
        return Number(this.currTeam.is_owner) === 1 || this.currTeam.is_owner === true
      }
      return Number(this.currTeam.belong_user_id) > 0 &&
        Number(this.currTeam.belong_user_id) === Number(this.$store.getters['user/user_id'])
    },
    canLeaveCurrentTeam() {
      return this.$store.getters['team/isEnterprise'] && !this.isCurrentTeamOwner
    },
    menus() {
      return [
        {
          code: '1',
          name: 'Home',
          show: true,
          icon: 'home-o',
          activeIcon: 'home-full',
          title: this.$t('layout.layout.home'),
          path: '/home',
          children: []
        },
        {
          code: '2',
          name: 'ChatCreation',
          show: true,
          icon: 'still_more',
          activeIcon: 'still_more_full',
          title: this.$t('layout.layout.conversation'),
          path: '/chat',
          children: []
        },
        {
          code: '3',
          name: 'Wiki',
          show: true,
          icon: 'questionnaire_whit',
          activeIcon: 'questionnaire_full',
          title: this.$t('layout.layout.projects'),
          path: '/projects',
          children: []
        },
        {
          code: '4',
          name: 'Assets',
          show: true,
          icon: 'folder-line',
          iconType: 'iconfont',
          title: this.$t('layout.layout.assets'),
          path: '/assets',
          children: []
        }
      ]
    },
    contactMenuItems() {
      const locale = String(this.languageValue || getLocale() || 'zh-cn').toLowerCase().replace('_', '-')
      const fieldMap = {
        'zh-cn': 'name_zh_cn',
        'zh-tw': 'name_zh_tw',
        'en-us': 'name_en_us'
      }
      const contactLabelMap = {
        'zh-cn': '联系我们',
        'zh-tw': '聯繫我們',
        'en-us': 'Contact us'
      }
      const field = fieldMap[locale] || 'name_zh_cn'
      const records = (this.contactMenuRecords || []).map(item => ({
        key: 'contact-menu-' + item.id,
        label: item[field] || item.name_zh_cn || item.name_zh_tw || item.name_en_us,
        url: item.url
      })).filter(item => item.label && item.url)
      return records.concat([{
        key: 'contact',
        label: contactLabelMap[locale] || contactLabelMap['zh-cn']
      }])
    },
    Bell() {
      return Bell
    },
    truncatedEmail() {
      const email = this.$store.getters['email'] || ''
      const maxBytes = 60 // 设置最大字节数

      if (this.$common.strLen(email) > maxBytes) {
        // 使用 cutByte 方法进行截断
        return this.$common.cutByte(email, maxBytes, '...')
      }
      return email
    },
    isEmailOverflow() {
      const email = this.$store.getters['email'] || ''
      return this.$common.strLen(email) > 20
    }
  },
  watch: {
    menuCollapse: {
      immediate: true,
      handler(val) {
        document.documentElement.style.setProperty('--highlight-left', val ? '3px' : '-15px')
      }
    },
    '$route.path': {
      immediate: true,
      handler(newPath) {
        this.updateActiveMenu(newPath)
      }
    },
    userMenuVisible(value) {
      if (!value) this.closeTeamMenu()
    },
    isLoggedIn(isLoggedIn, wasLoggedIn) {
      if (isLoggedIn && !wasLoggedIn) {
        this.getUserTeam()
        return
      }
      if (!isLoggedIn && wasLoggedIn) {
        this.$store.dispatch('team/reset')
        this.userMenuVisible = false
        this.inviteMenuVisible = false
        this.dialogAccountCenter = false
        this.dialogSubscriptionPurchase = false
        this.dialogInviteReward = false
        this.dialogBindInviteCode = false
      }
    }
  },
  mounted() {
    this.languageValue = getLocale()
    this.loadContactMenuItems()
    this.themeValue = getTheme() // 初始化主题值
    let path = this.$router.currentRoute.value.path
    if (path.indexOf('/chat') >= 0) {
      path = '/chat'
    }
    this.updateActiveMenu(path)
    this.$router.afterEach((to) => {
      this.updateActiveMenu(to.path)
    })
    document.addEventListener('click', this.handleGlobalClick)
    window.addEventListener('resize', this.handleTeamMenuViewportChange)
    const menu = this.menus.find(o => o.path === path)
    if (menu) {
      this.menuActiveIndex = menu.code
    }
    this.curPath = path
    if (this.isLoggedIn) {
      this.getUserTeam()
    }

    this.$nextTick(() => {
      this.languageMenuRef = document.querySelector('.language-menu-trigger')
    })
    
    // 监听来自其他组件的打开订阅页面事件
    this.globalEventBus.on('openSubscriptionPage', this.openSubPage)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleGlobalClick)
    window.removeEventListener('resize', this.handleTeamMenuViewportChange)
    this.cancelHideContactMenu()
    // 清理事件监听
    this.globalEventBus.off('openSubscriptionPage', this.openSubPage)
  },
  methods: {
    openLogin() {
      requireAuth({
        reason: 'auth_required',
        redirect: this.$route.fullPath
      })
    },
    loadPreferences() {
      if (!isAuthenticated()) return Promise.resolve(null)
      getPreferenceConfigs()
        .then(({ code, data }) => {
          if (code === 0) {
            console.log(data)
            this.languageOptions = (data.find(c => c.key === 'language')?.data || []).sort((a, b) => {
              const order = { 'en-us': 1, 'zh-cn': 2, 'zh-tw': 3 }
              return (order[a.key] || 999) - (order[b.key] || 999)
            })
            const themeOptionsData = data.find(c => c.key === 'theme')?.data || []
            this.themeOptions = themeOptionsData.map(item => {
              return {
                ...item,
                name: this.$t(`layout.layout.${item.key}`)
              }
            })
            this.setCurrentLanguage()
          }
        })
        .catch(e => {
          console.error('配置加载失败:', e)
        })
    },
    getCurrentPreferences() {
      if (!isAuthenticated()) return Promise.resolve(null)
      getUserPreference()
        .then(({ code, data }) => {
          if (code === 0) {
            // 从后端获取主题设置并转换为对应的key
            const themeKey = getThemeKeyById(data.theme_id)
            const userSetLanguage = data.language_key.toLowerCase()
            if (userSetLanguage !== this.languageValue) {
              this.languageValue = userSetLanguage
              this.handleLangCommand(userSetLanguage, 0)
            }
            if (themeKey !== this.themeValue) {
              this.themeValue = themeKey
              switchTheme(this.themeValue, this.$store)
            }
          }
        })
        .catch(e => {
          console.error('用户设置加载失败:', e)
        })
    },
    themeValueChange() {
      // 应用主题变更
      const actual = switchTheme(this.themeValue, this.$store)
      // 广播主题变更，供 BlockNote/Mermaid 等订阅
      EventBus.emit('blocknote-theme-change', actual)
      this.savePreferences()
    },
    languageValueChange() {
      this.savePreferences()
    },
    savePreferences() {
      const params = {
        theme_id: this.themeOptions.find(t => t.key === this.themeValue)?.id,
        language_id: this.languageOptions.find(l => l.key === this.languageValue)?.id
      }
      const localeLanguage = getLocale()
      updateUserPreference(params).then(response => {
        if (localeLanguage !== this.languageValue) {
          this.changeLanguage()
        }
        // 主题切换不需要重新加载页面，已在themeValueChange中处理
      })
        .catch(error => {
          if (localeLanguage !== this.languageValue) {
            this.changeLanguage()
          }
          console.error('保存失败:', error)
        })
    },
    goToDashboard() {
      this.$router.push({name: 'Home'})
    },
    toggleMenuCollapse() {
      this.menuCollapse = true
    },
    changeNav(item) {
      if (['/chat', '/projects', '/assets'].includes(item.path) && !requireAuth({
        reason: item.path === '/chat' ? 'chat' : item.path === '/projects' ? 'knowledge' : 'assets',
        redirect: item.path
      })) {
        return
      }
      this.$nextTick(() => {
        if (this.$refs['createTeamDlg']) {
          this.$refs['createTeamDlg'].hide()
        }
      })
      this.curPath = item.path
      this.$router.push({path: item.path})
    },
    openAccountCenter() {
      if (!requireAuth({ reason: 'account', redirect: this.$route.fullPath })) return
      this.closeTeamMenu()
      this.languagePopoverVisible = false
      this.userMenuVisible = false
      this.dialogAccountCenter = true
    },
    openSubPage() {
      if (!requireAuth({ reason: 'subscription', redirect: this.$route.fullPath })) return
      if (!this.canManageSubscription) {
        this.$message.warning(this.$t('views.account_center.purchase_owner_only'))
        return
      }
      this.closeTeamMenu()
      this.languagePopoverVisible = false
      this.userMenuVisible = false
      this.dialogSubscriptionPurchase = true
    },
    openSubscriptionCenter() {
      if (!requireAuth({ reason: 'subscription', redirect: this.$route.fullPath })) return
      this.closeTeamMenu()
      this.languagePopoverVisible = false
      this.userMenuVisible = false
      this.dialogAccountCenter = true
      this.$nextTick(() => {
        EventBus.emit('setActiveMenu', 'subscription_manage', { resetTab: true })
      })
    },
    accountCenterPaymentSuccess(payload){
      this.handleSubscriptionPaymentSuccess(payload)
      this.dialogAccountCenter = false
      this.handleSubscriptionDialogClosed()
    },
    handleSubscriptionPaymentSuccess(payload) {
      this.pendingSubscriptionPaymentSuccess = payload?.dialogData || null
      this.dialogSubscriptionPurchase = false
    },
    handleSubscriptionDialogClosed() {
      if (!this.pendingSubscriptionPaymentSuccess) return
      this.subscriptionPaymentSuccessData = this.pendingSubscriptionPaymentSuccess
      this.pendingSubscriptionPaymentSuccess = null
      this.subscriptionPaymentSuccessVisible = true
    },
    closeSubscriptionPaymentSuccess() {
      this.subscriptionPaymentSuccessVisible = false
    },
    toggleUserMenu(event) {
      event.stopPropagation()
      if (!requireAuth({ reason: 'account', redirect: this.$route.fullPath })) return
      this.userMenuVisible = !this.userMenuVisible
      if (!this.userMenuVisible) this.closeTeamMenu()

      if (this.userMenuVisible) {
        this.getCurrentPreferences()
        this.loadPreferences()
        if(!this.$store.getters['team/currentTeam']){
          this.getUserTeam()
        }
        this.$store.dispatch('team/loadCurrentContext')
        this.inviteMenuVisible = false
      }

      // 如果点击时已经打开语言菜单，则关闭它
      if (this.languagePopoverVisible) {
        this.languagePopoverVisible = false
      }

      if (this.userMenuVisible) {
        this.$nextTick(() => {
          const trigger = this.userMenuTrigger
          if (trigger) {
            const rect = trigger.getBoundingClientRect()
            const windowHeight = window.innerHeight
            const menuHeight = 300

            if (windowHeight - rect.bottom < menuHeight) {
              // 向上弹出
              this.userMenuPosition.left = `${rect.right + 15}px`
              this.userMenuPosition.top = 'auto'
              this.userMenuPosition.bottom = `${windowHeight - rect.top}px`
            } else {
              // 向下弹出
              this.userMenuPosition.left = `${rect.right + 15}px`
              this.userMenuPosition.top = `${rect.top - 90}px`
              this.userMenuPosition.bottom = 'auto'
            }
          }
        })
      }
    },
    toggleTeamMenu() {
      if (!this.userMenuVisible) return
      this.teamMenuVisible = !this.teamMenuVisible
      this.languagePopoverVisible = false
      if (!this.teamMenuVisible) return

      this.$nextTick(() => this.updateTeamMenuPosition())
    },
    closeTeamMenu() {
      this.teamMenuVisible = false
    },
    handleTeamMenuViewportChange() {
      if (this.teamMenuVisible) this.updateTeamMenuPosition()
    },
    updateTeamMenuPosition() {
      const trigger = this.teamMenuTrigger
      const popover = document.querySelector('.team-switch-popover')
      if (!trigger || !popover) return

      const rect = trigger.getBoundingClientRect()
      const viewportPadding = 12
      const gap = 8
      const popoverWidth = popover.offsetWidth || 240
      const popoverHeight = popover.offsetHeight || 220
      const canOpenRight = rect.right + gap + popoverWidth <= window.innerWidth - viewportPadding
      const left = canOpenRight
        ? rect.right + gap
        : Math.max(viewportPadding, rect.left - gap - popoverWidth)
      const top = Math.max(
        viewportPadding,
        Math.min(rect.top, window.innerHeight - popoverHeight - viewportPadding)
      )

      this.teamMenuPosition.left = `${left}px`
      this.teamMenuPosition.right = 'auto'
      this.teamMenuPosition.top = `${top}px`
      this.teamMenuPosition.bottom = 'auto'
    },
    getTeamDisplayName(team) {
      if (Number(team && team.team_type) > 0) {
        return this.$store.getters['user/nick_name'] ||
          team.name ||
          this.$t('layout.layout.personal_team')
      }
      return (team && team.name) || this.$t('layout.layout.enterprise_team')
    },
    getTeamIconClass(team) {
      return Number(team && team.team_type) > 0 ? 'icon-user' : 'icon-company'
    },
    isCurrentTeam(team) {
      return Number(team && team.team_id) === Number(this.$store.getters['user/current_team_id'])
    },
    showContactMenu() {
      this.cancelHideContactMenu()
      this.contactInfoVisible = true
      this.closeTeamMenu()
      this.userMenuVisible = false
      this.languagePopoverVisible = false
      this.inviteMenuVisible = false

      if (this.contactInfoVisible) {
        this.$nextTick(() => {
          const trigger = this.contactInfoTrigger
          const menu = document.querySelector('.contact-menu-popover')
          if (!trigger || !menu) return

          const rect = trigger.getBoundingClientRect()
          const menuHeight = menu.offsetHeight || 96
          const viewportPadding = 12
          const centeredTop = rect.top + (rect.height / 2) - (menuHeight / 2)
          const top = Math.max(
            viewportPadding,
            Math.min(centeredTop, window.innerHeight - menuHeight - viewportPadding)
          )

          this.contactInfoPosition.left = `${rect.right + 15}px`
          this.contactInfoPosition.top = `${top}px`
          this.contactInfoPosition.right = 'auto'
          this.contactInfoPosition.bottom = 'auto'
        })
      }
    },
    loadContactMenuItems() {
      getContactMenuList().then(response => {
        if (response && response.code === 0 && Array.isArray(response.data)) {
          this.contactMenuRecords = response.data
        }
      }).catch(error => {
        // 联系菜单属于增强配置，读取失败时保留固定的“联系我们”入口。
        console.warn('加载联系我们菜单失败:', error)
      })
    },
    openContactMenuItem(item) {
      if (item.key === 'contact') {
        this.openContactDialog()
        return
      }
      if (item.url) {
        window.open(item.url, '_blank', 'noopener,noreferrer')
      }
    },
    scheduleHideContactMenu() {
      this.cancelHideContactMenu()
      this.contactMenuHideTimer = window.setTimeout(() => {
        this.contactInfoVisible = false
        this.contactMenuHideTimer = null
      }, 220)
    },
    cancelHideContactMenu() {
      if (this.contactMenuHideTimer) {
        window.clearTimeout(this.contactMenuHideTimer)
        this.contactMenuHideTimer = null
      }
    },
    openContactDialog() {
      this.cancelHideContactMenu()
      this.contactInfoVisible = false
      this.contactDialogVisible = true
    },
    toggleLanguagePopover(event) {
      event.stopPropagation()
      this.closeTeamMenu()
      this.languagePopoverVisible = !this.languagePopoverVisible

      if (this.languagePopoverVisible) {
        this.$nextTick(() => {
          const menuEl = this.$refs.languageMenuRef
          if (menuEl) {
            const rect = menuEl.getBoundingClientRect()
            const windowHeight = window.innerHeight
            const windowWidth = window.innerWidth
            const popoverWidth = 110 // 语言弹窗宽度
            const popoverHeight = 150 // 估算的语言菜单高度

            // 判断是否靠近右边缘
            if (windowWidth - rect.right < popoverWidth + 10) {
              // 向左弹出
              this.languageMenuPosition.right = `${windowWidth - rect.left + 5}px`
              this.languageMenuPosition.left = 'auto'
            } else {
              // 向右弹出
              this.languageMenuPosition.left = `${rect.right + 5}px`
              this.languageMenuPosition.right = 'auto'
            }

            // 判断是否靠近底部
            if (windowHeight - rect.bottom < popoverHeight) {
              // 向上弹出，但避免太高
              this.languageMenuPosition.top = 'auto'
              this.languageMenuPosition.bottom = `${windowHeight - rect.top - 136}px`
            } else {
              // 向下弹出，向上移动
              this.languageMenuPosition.top = `${rect.top}px`
              this.languageMenuPosition.bottom = 'auto'
            }
          }
        })
      }
    },
    changeLanguage() {
      // 如果事件对象存在，阻止冒泡
      this.handleLangCommand(this.languageValue)

      // 关闭语言弹窗，但保持用户菜单打开
      this.languagePopoverVisible = false

      // 这里添加切换语言的具体实现
    },
    handleGlobalClick(event) {
      // 处理用户菜单
      const userMenuEl = this.userMenuTrigger
      const userMenuContainer = document.querySelector('.custom-user-menu-container')
      const teamMenuContainer = document.querySelector('.team-switch-popover')

      if ((!userMenuEl || !userMenuEl.contains(event.target)) &&
          (!userMenuContainer || !userMenuContainer.contains(event.target)) &&
          (!teamMenuContainer || !teamMenuContainer.contains(event.target))) {
        this.userMenuVisible = false
      }

      const teamMenuTrigger = this.teamMenuTrigger
      if ((!teamMenuTrigger || !teamMenuTrigger.contains(event.target)) &&
          (!teamMenuContainer || !teamMenuContainer.contains(event.target))) {
        this.closeTeamMenu()
      }

      // 处理语言菜单
      const languageMenuEl = this.$refs.languageMenuRef
      const popoverEl = document.querySelector('.language-popover-container')

      if ((!languageMenuEl || !languageMenuEl.contains(event.target)) &&
          (!popoverEl || !popoverEl.contains(event.target))) {
        this.languagePopoverVisible = false
      }

      // 处理邀请菜单
      const inviteMenuEl = document.querySelector('.invite-menu-popover')
      const inviteRewardEntry = document.querySelector('.invite-reward-entry')
      if ((!inviteRewardEntry || !inviteRewardEntry.contains(event.target)) &&
          (!inviteMenuEl || !inviteMenuEl.contains(event.target))) {
        this.inviteMenuVisible = false
      }

      const contactInfoTrigger = this.contactInfoTrigger
      const contactInfoPopover = document.querySelector('.contact-menu-popover')
      if ((!contactInfoTrigger || !contactInfoTrigger.contains(event.target)) &&
          (!contactInfoPopover || !contactInfoPopover.contains(event.target))) {
        this.contactInfoVisible = false
      }
    },
    toggleInviteMenu(event) {
      event.stopPropagation()
      if (!requireAuth({ reason: 'invite', redirect: this.$route.fullPath })) return
      this.inviteMenuVisible = !this.inviteMenuVisible

      if (this.inviteMenuVisible) {
        this.closeTeamMenu()
        this.userMenuVisible = false
        this.languagePopoverVisible = false
        this.$nextTick(() => {
          const trigger = event.currentTarget
          if (trigger) {
            const rect = trigger.getBoundingClientRect()
            this.inviteMenuPosition.left = `${rect.right + 15}px`
            const popover = document.querySelector('.invite-menu-popover')
            const menuHeight = popover ? popover.offsetHeight : 90
            this.inviteMenuPosition.top = `${rect.top + (rect.height / 2) - (menuHeight / 2)}px`
            this.inviteMenuPosition.bottom = 'auto'
          }
        })
      }
    },
    openInviteReward() {
      if (!requireAuth({ reason: 'invite', redirect: this.$route.fullPath })) return
      this.inviteMenuVisible = false
      this.dialogInviteReward = true
    },
    openBindInviteCode() {
      if (!requireAuth({ reason: 'invite', redirect: this.$route.fullPath })) return
      this.inviteMenuVisible = false
      this.dialogBindInviteCode = true
    },
    openMenu(key, keyPath) {
    },
    closeMenu(key, keyPath) {
    },
    updateActiveMenu(path) {
      if (path.indexOf('/chat') >= 0) {
        path = '/chat'
      } else if (path.indexOf('/projects') >= 0) {
        path = '/projects'
      } else if (path.indexOf('/assets') >= 0) {
        path = '/assets'
      }
      const menu = this.menus.find(o => o.path === path)
      if (menu) {
        this.menuActiveIndex = menu.code
      }
      this.curPath = path
    },
    userLogout() {
      this.$confirm(this.$t('layout.layout.confirm_logout'), this.$t('layout.layout.logout_system'), {
        confirmButtonText: this.$t('layout.layout.exit'),
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        await this.$store.dispatch('user/logout')
        this.$router.replace('/home')
      }).catch(() => {
        // 用户取消操作，不做任何处理
      })
    },
    closeDialogCreateTeam() {
      this.dialogCreateTeam = false
    },
    submitCreateTeam() {
      this.$refs['createTeamDlg'].createTeam()
    },
    showDialogCreateTeam() {
      this.closeTeamMenu()
      this.dialogCreateTeam = true
      this.$nextTick(() => {
        if (this.$refs['createTeamDlg']) {
          this.$refs['createTeamDlg'].initCreateTeam()
        }
      })
      this.userMenuVisible = false
    },
    closeDialogJoinTeam() {
      this.dialogJoinTeam = false
    },
    submitJoinTeam() {
      this.$refs['joinTeamDlg'].joinTeam()
    },
    showDialogJoinTeam() {
      this.closeTeamMenu()
      this.dialogJoinTeam = true
      this.$nextTick(() => {
        if (this.$refs['joinTeamDlg']) {
          this.$refs['joinTeamDlg'].initJoinTeam()
        }
      })
      this.userMenuVisible = false
    },
    confirmLeaveCurrentTeam() {
      this.$confirm(
        this.$t('layout.layout.confirm_leave_team'),
        this.$t('common.tips'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      ).then(() => this.leaveCurrentTeam()).catch(() => {})
    },
    async leaveCurrentTeam() {
      try {
        const response = await leaveTeam({})
        if (!response || response.code !== 0) return
        this.$message.success(this.$t('layout.layout.leave_team_success'))
        const teams = await this.getUserTeam()
        const personalTeam = (teams || []).find(item => Number(item.team_type) > 0)
        if (personalTeam && personalTeam.team_id) {
          await this.switchUserCurrIdentity(personalTeam.team_id)
        } else {
          this.userMenuVisible = false
        }
      } catch (error) {
        // request.js already surfaces the backend error message
      }
    },
    updateTeam(id) {
      this.closeDialogCreateTeam()
      this.closeDialogJoinTeam()
      this.switchUserCurrIdentity(id)
      this.getUserTeam()
    },
    async switchUserCurrIdentity(teamId) {
      if (!teamId || this.teamSwitchingId !== null) return
      if (Number(this.$store.getters['user/current_team_id']) === Number(teamId)) {
        this.closeTeamMenu()
        return
      }

      this.teamSwitchingId = teamId
      try {
        const response = await switchCurrIdentity({ current_team_id: teamId })
        if (response && response.code === 0) window.location.href = '/'
      } catch (error) {
        // request.js already surfaces the backend error message
      } finally {
        this.teamSwitchingId = null
      }
    },
    openTeamManagement() {
      this.closeTeamMenu()
      this.userMenuVisible = false
      this.$router.push('/org-admin/index')
    },
    getUserTeam() {
      if (!isAuthenticated()) return Promise.resolve([])
      return this.$store.dispatch('team/load').catch(() => [])
    },
    showDialogTeamInvitation() {
      this.dialogTeamInvitation = true
      this.userMenuVisible = false
    },
    confirmTeamInvitation() {
      this.dialogTeamInvitation = false
    },
    submitTeamInvitation() {
      this.$refs['teamInvitationDlg'].submitOption()
    },
    setCurrentLanguage() {
      if (this.languageOptions.length > 0) {
        this.currentLanguage = this.languageOptions.find(item => item.key === this.languageValue)
      }
    },
    async handleLangCommand(command, isReload = 1) {
      console.log(this.menus)
      const paramsLocale = command
      // 暂时先注释 本地有配置文件 后续更改为从后端获取
      await setLocale(i18n, paramsLocale)
      setI18nLanguage(i18n, paramsLocale)
      document.title = getPageTitle(this.$t(this.$route.meta.title))

      // 更新主题选项的翻译名称
      if (this.themeOptions.length > 0) {
        this.themeOptions = this.themeOptions.map(theme => {
          return {
            ...theme,
            name: this.$t(`layout.layout.${theme.key}`)
          }
        })
      }

      this.setCurrentLanguage()
      // this.menus = [...this.menus]
      if (isReload) {
        window.location.reload()
      }
    }
  }
}
</script>

<style lang="scss">
.accountCenterBox{
  padding: 0 !important;
  border-radius: 6px;
  .el-dialog__header {
    padding:0 !important;
  }
  .account-center-container {
    line-height: normal;
  }
}
.subscriptionPurchaseBox {
  max-width: calc(100vw - 28px);
  padding: 0 !important;
  overflow: hidden;
  border-radius: 10px;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}
.invite-reward-dialog {
  border-radius: 16px;
  .el-dialog__header {
    padding: 0 !important;
  }
}
.contact-dialog {
  max-width: calc(100vw - 32px);
  border-radius: 12px;

  .el-dialog__header {
    padding: 24px 24px 12px;
    margin-right: 0;
  }

  .el-dialog__title {
    color: var(--agst-text-color-primary,#303133);
    font-size: 20px;
    font-weight: 600;
  }

  .el-dialog__body {
    padding: 8px 24px 24px;
  }

  .contact-dialog-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .contact-dialog-section {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .contact-dialog-caption {
    color: var(--agst-text-color-primary,#303133);
    font-size: var(--agst-font-size-base,14px);
    font-weight: 600;
  }

  .contact-dialog-value,
  .contact-dialog-link {
    color: var(--agst-text-color-primary,#303133);
    font-size: var(--agst-font-size-base,14px);
    line-height: 1.55;
    word-break: break-all;
  }

  .contact-dialog-link {
    color: var(--agst-color-primary,#2D66F0);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .contact-dialog-qrcode {
    width: 116px;
    height: 116px;
    margin-top: 2px;
    border-radius: 4px;
    background: #fff;
  }
}
</style>
<style lang="scss" scoped>
@import '~@/assets/iconfont/iconfont.css';
@import '@/assets/css/layout.scss';
</style>

